import React from "react";
import { AppBar, translate } from "react-admin";
import UserIcon from "@material-ui/icons/AccountBox";
import AppBarTitle from "./AppBarTitle";
import { getLoggedUser } from "../common/authClient";
import CustomUserMenu from "../components/CustomUserMenu";

class MyProfile extends React.Component {
    state = {
        logged_user_id: null,
        fetchingData: false,
        user: null
    };

    componentDidMount() {
        getLoggedUser().then(logged_user => {
            if (logged_user) {
                this.setState({
                    logged_user_id: logged_user.id,
                    user: logged_user
                });
            }
        });
    }

    render() {
        return this.state.logged_user_id ? (
            <span>
                <a
                    href="/polar/profile"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "8px 16px",
                        textDecoration: "none",
                        color: "inherit",
                        cursor: "pointer"
                    }}
                    onClick={this.props.onClick}
                >
                    <UserIcon style={{ marginRight: 8 }} />
                    Profilo
                </a>
            </span>
        ) : null;
    }
}

const UserMenu = translate(({ translate, ...props }) => (
    <React.Fragment>
        <AppBarTitle />
        <CustomUserMenu {...props}>
            <MyProfile />
        </CustomUserMenu>
    </React.Fragment>
));

const CustomAppBar = props => {
    return <AppBar {...props} userMenu={<UserMenu />} />;
};

export default CustomAppBar;



// WEBPACK FOOTER //
// ./src/components/AppBar.js